import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import { v4 as uuidv4 } from 'uuid';
import { Button, TextField, Grid, Typography } from '@mui/material';

const CaseForm = (props) => {
  const [case_, setCase] = useState({
    name: props.case ? props.case.casename : '',
    external_uid: props.case ? props.case.external_uid: '',
  });

  const [errorMsg, setErrorMsg] = useState('');
  const { name, external_uid} = case_;

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const values = [name];
    let errorMsg = '';

    const allFieldsFilled = values.every((field) => {
      const value = `${field}`.trim();
      return value !== '' && value !== '0';
    });

    if (allFieldsFilled) {
      const case_ = {
        external_reference_uid: uuidv4(),
        name,
      };
      props.handleOnSubmit(case_);
    } else {
      errorMsg = 'Please fill out all the fields.';
    }
    setErrorMsg(errorMsg);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      default:
        setCase((prevState) => ({
          ...prevState,
          [name]: value
        }));
    }
  };

  return (
    <div className="main-form">
      {errorMsg && <p className="errorMsg">{errorMsg}</p>}
      <FormControl> 
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <TextField
              label="Case Name"
              name="name"
              value={name}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="text" onClick={() => props.handleBack() } > 
              Back 
            </Button>
            <Button onClick={(e) => handleOnSubmit(e)} variant="contained" type="submit" className="submit-btn">
              Submit
            </Button>
          </Grid>
        </Grid>
      </FormControl>
    </div>
  );
};

export default CaseForm;
